import { alpha } from '@mui/material/styles';

export default function Table(theme) {
  const isDark = theme.palette.mode === 'dark';
  const linkColor = theme.palette.brand.link;
  const hoverColor = theme.palette.brand.linkHover;

  return {
    MuiTableCell: {
      styleOverrides: {
        root: {
          borderBottom: `1px solid ${alpha(theme.palette.divider, isDark ? 0.7 : 0.4)}`,
          color: theme.palette.text.primary,
          '& a': {
            color: linkColor,
            fontWeight: isDark ? 600 : 500,
            textDecoration: 'none',
            textUnderlineOffset: 4,
            transition: theme.transitions.create(['color', 'text-decoration'], {
              duration: theme.transitions.duration.shorter
            }),
            '&:hover': {
              color: hoverColor,
              textDecoration: 'underline'
            }
          }
        },
        head: {
          fontWeight: 600,
          letterSpacing: 0.25,
          textTransform: 'uppercase',
          color: theme.palette.text.secondary,
          borderBottom: `2px solid ${alpha(theme.palette.divider, isDark ? 0.9 : 0.6)}`
        }
      }
    },
    MuiTableRow: {
      styleOverrides: {
        root: {
          transition: theme.transitions.create('background-color'),
          '&:hover': {
            backgroundColor: alpha(theme.palette.primary.main, isDark ? 0.08 : 0.04)
          }
        }
      }
    }
  };
}
